var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'Login' && _vm.$store.state.isLoggedIn())?_c('TopMenu',{staticClass:"mb-3"}):_vm._e(),_c('router-view',{class:{
    container: _vm.$route.meta.hasContainer
  }}),_c('Modals'),_c('FullScreenLoading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }